<template>
  <div class="chat">
    <div class="chat-container" id="chatBar" @scroll="onScroll">
      <ul>
        <li class="chat-item" v-for="(item, index) in chatList" :key="index">
          <div class="chat-name-container">
            <div class="user-name van-ellipsis">{{ item.talkManName }}</div>
          </div>
          <div class="content" v-html="item.talkInfo"></div>
        </li>
      </ul>
      <div class="no-data" v-if="chatList.length === 0">
        <img src="./../../assets/image/no-data.png" alt="" />
      </div>
    </div>

    <!-- :showQuestion="isAuth" -->
    <chat-btn @on-send="send" />
  </div>
</template>

<script>
import {insertMsg} from '@/api'
export default {
  components: {
    chatBtn: () => import('./chatBtn.vue')
    // messageBtn: () => import('./messageBtn')
  },
  props: ['chatList', 'ws'],
  data() {
    return {
      id: this.$route.params.id,
      isBottom: true
    }
  },
  computed: {
    userInfo() {
      return this.$store.state.userInfo
    },
    /* 活动基础信息 */
    activeInfo() {
      return this.$store.state.activePlay.activeInfo
    },
    eventInfo() {
      if (this.activeInfo) {
        return this.activeInfo.eventInfo
      }
      return {}
    }
  },
  mounted() {
    this.chatBar = document.querySelector('#chatBar')
    this.scrollBottom()
  },
  watch: {
    chatList() {
      if (!this.isBottom) return
      this.scrollBottom()
    }
  },
  methods: {
    send(msg) {
      if (this.id && this.userInfo.id) {
        const params = {
          eventInfoId: this.id,
          eventMessageInfo: msg,
          eventMessageType: 1 // -留言类型 1：直播聊天，2：留言  测试
        }
        insertMsg(params)
          .then(res => {
            if (res.code === 0 && res.success) {
              const obj = {
                c: 1000,
                d: {
                  r: this.id,
                  n: this.userInfo.name,
                  i: this.userInfo.id,
                  f: this.userInfo.userFace,
                  m: msg,
                  t: new Date()
                }
              }
              const json_str = JSON.stringify(obj)
              this.ws.send(json_str)
            }
          })
          .catch(() => {
            this.$Toast('发送失败')
          })
      } else {
        // this.$Toast('聊天需要登录')
        this.$dialog
          .alert({
            closeOnClickOverlay: true,
            theme: 'round-button',
            confirmButtonColor: '#4465f3',
            message: '您没有登录,去登录?'
          })
          .then(() => {
            this.$router.replace(`/login?redirect=${encodeURIComponent(location.href)}`)
          })
      }
    },
    onScroll() {
      if (this.chatBar.scrollTop + this.chatBar.clientHeight >= this.chatBar.scrollHeight) {
        this.isBottom = true
      } else {
        this.isBottom = false
      }
    },
    scrollBottom() {
      this.$nextTick(() => {
        if (this.chatBar.scrollHeight) {
          this.chatBar.scrollTop = this.chatBar.scrollHeight
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.chat {
  background: #f8f9fb;
  height: 100%;
  padding-bottom: 60px;
}
.chat-container {
  height: 100%;
  overflow: auto;
  &::-webkit-scrollbar {
    display: none;
  }
}
.no-data {
  text-align: center;
  padding-top: 60px;
  img {
    width: 140px;
  }
}
.chat-item {
  position: relative;
  padding: 6px 10px;
  display: flex;
  .chat-name-container {
    max-width: 102px;
  }
  .user-name {
    position: relative;
    color: #909399;
    padding-right: 4px;
    &::before {
      content: ':';
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-50%);
    }
  }
  .content {
    flex: 1;
    // padding-left: 106px;
    margin-left: 10px;
    color: #303133;
    font-size: 14px;
    line-height: 1.5;
    word-break: break-all;
  }
}
</style>
